import {Station} from "../stations/station.service.interface";
import {TimeSpan} from "../../types/time-span";

export enum FlightScheduleAvailabilityStatusEnum {
    NotAvailable = 1,
    Reading = 2,
    Available = 3,
    SoldOut = 4
}
export interface IFlightDateScheduleAvailability {
    status: FlightScheduleAvailabilityStatusEnum;
}

export interface IFlightScheduleDayCache {
    isExpired: boolean;
    dayScheduleStatus: FlightScheduleAvailabilityStatusEnum | null;
}

export interface IFlightScheduleCache {
    isCacheExpired(origin: string, destination: string, date: string): boolean;
    getFromCache(origin: string, destination: string, date: string): IFlightScheduleDayCache | null;
    putInCache(origin: string, destination: string, date: string, status: FlightScheduleAvailabilityStatusEnum): void;
    setExpirationTime(origin: string, destination: string, timeSpanFromNow: TimeSpan): void;
}

export interface IFlightsScheduleService {
    getDaySchedule(originStation: Station, destinationStation: Station, date: Date): IFlightDateScheduleAvailability;
    getDayScheduleAsync(originStation: Station, destinationStation: Station, date: Date): Promise<IFlightDateScheduleAvailability>;
}

